<template>
  <div>
    <Segment v-model="segment" :items="items" block />

    <div v-show="segment === 'current'" class="mt-6">
      <p class="text-[14px] leading-[22px] text-gray-800">
        You'll be charged using your saved card.
      </p>
      <div
        v-if="card"
        class="mt-4 flex items-center gap-2.5 text-[14px] text-gray-800"
      >
        <CreditCard :type="card.type" />
        <span>•••• •••• •••• {{ card.last4 }}</span>
      </div>
    </div>

    <div v-show="segment === 'new'" class="mt-6">
      <div class="flex flex-col items-center text-center">
        <CreditCardIcon class="h-9 w-12 text-gray-800" />
        <h2 class="mt-3 text-[18px] font-medium leading-6 text-gray-800">
          Add payment method
        </h2>
        <p class="mt-1.5 text-[14px] leading-5 text-gray-500">
          Verify and complete your card information.
        </p>
      </div>
      <div id="card" class="mt-6" />
    </div>

    <Alert v-if="errorMessage" variant="error" :icon="AlertIcon" class="mt-3">
      {{ errorMessage }}
    </Alert>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Segment, Alert } from '@dacr/library'
import { CreditCardIcon, AlertIcon } from '@dacr/icons'

import CreditCard from '@/features/billing/components/CreditCard.vue'
import { useBillingStore } from '@/features/billing/store'

const segment = defineModel<string>('segment', { required: true })
defineProps<{ errorMessage: string }>()

const billingStore = useBillingStore()
const card = computed(() => billingStore.billing?.paymentMethod?.card)

const items = computed(() =>
  card.value
    ? [
        { label: 'Current', value: 'current' },
        { label: 'New payment method', value: 'new' },
      ]
    : [{ label: 'New payment method', value: 'new' }]
)
</script>
